























































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import {
  KCardFooterBtn,
} from '@kasasa/fbase-components';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { TunesSummary, TunesSummaryResource } from '@/api/tunessummary';
import { Cycle } from '@/api/cycles';

interface TunesSummaryTableEntry {
  tunesSummary: TunesSummary,
  expanded: boolean,
  children: TunesSummaryTableEntry[] | null
}

@Component({
  computed: mapState(['fiId']),
})
export default class TunesSummaryTable extends Vue {
  @Prop({ default: null }) cycle!: Cycle | null;

  fiId!: string;

  loading: boolean = true;

  headers: DataTableHeader[] = [
    { text: '', value: 'toggle', width: '1px' },
    { text: 'Product', value: 'productName' },
    { text: 'Branch', value: 'branch' },
    { text: 'Tunes Credit Paid', value: 'totalTunesCreditPaid' },
    { text: 'Tunes Grants Expired Unused', value: 'tunesGrantsExpiredUnused' },
  ];

  items: TunesSummaryTableEntry[] = [];

  @Inject('TunesSummaryResource')
  tunesSummaryResource!: TunesSummaryResource;

  mounted() {
    this.loadData();
  }

  @Watch('cycle')
  async loadData() {
    if (this.cycle) {
      this.loading = true;
      this.items = [];

      await this.tunesSummaryResource.getTunesSummary(this.fiId, this.cycle.id, null)
        .then((results: TunesSummary[]) => {
          results.forEach((summary: TunesSummary) => {
            const productEntry: TunesSummaryTableEntry = {
              tunesSummary: summary,
              expanded: false,
              children: null,
            };
            this.items.push(productEntry);
          });
        }).catch((error: any) => {
          this.showErrorMessage(error);
        }).finally(() => {
          this.loading = false;
        });
    }
  }

  populateChildrenIfNecessary(productEntry: TunesSummaryTableEntry) {
    if (productEntry.children === null && this.cycle) {
      this.tunesSummaryResource.getTunesSummary(this.fiId, this.cycle.id, productEntry.tunesSummary.productId)
        .then((results: TunesSummary[]) => {
          const children: TunesSummaryTableEntry[] = [];
          /* eslint-disable no-param-reassign */
          results.forEach((summary: TunesSummary) => {
            summary.productId = productEntry.tunesSummary.productId;
            const childEntry: TunesSummaryTableEntry = {
              tunesSummary: summary,
              expanded: false,
              children: null,
            };
            children.push(childEntry);
          });
          productEntry.children = children;
          /* eslint-enable no-param-reassign */
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  getTableValue = (item: TunesSummary, header: DataTableHeader): String => {
    switch (header.value) {
      case 'productName':
        return item.tunesSummary.productName;
      case 'branch':
        return item.tunesSummary.branch;
      default:
        return TunesSummaryTable.formatDollarAmount(item.tunesSummary[header.value]);
    }
  }

  static formatDollarAmount(value: any) {
    return `${value !== null ? `$${Number(value).toFixed(2)}` : ''}`;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
